import React, { useLayoutEffect, useRef } from 'react';
import { Label } from 'semantic-ui-react';
import { logClientIdentityV94 } from './clientDisplayV94';

// One observer handles all rows, including the 5000-row log view.
let overflowObserver;
const updateOverflow = (element) => {
  element.classList.toggle(
    'log-client-overflow-v94',
    element.scrollWidth > element.clientWidth
  );
};

export default function LogClientIdentityV94({ log }) {
  const { name, version, userAgent } = logClientIdentityV94(log);
  const label = name || '-';
  const labelRef = useRef(null);
  const title = [label, version].filter(Boolean).join(' ');
  const tooltip =
    userAgent && userAgent !== name ? `${title}\n${userAgent}` : title;

  useLayoutEffect(() => {
    const element = labelRef.current;
    updateOverflow(element);
    if (typeof ResizeObserver === 'undefined') {
      const resize = () => updateOverflow(element);
      window.addEventListener('resize', resize);
      return () => window.removeEventListener('resize', resize);
    }
    if (!overflowObserver) {
      overflowObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => updateOverflow(target));
      });
    }
    overflowObserver.observe(element);
    return () => overflowObserver.unobserve(element);
  }, [label]);

  return (
    <div className='log-client-cell-v94' title={tooltip}>
      <span ref={labelRef} className='log-client-name-v94'>
        {label}
      </span>
      {version && (
        <div>
          <Label basic size='mini'>
            {version}
          </Label>
        </div>
      )}
    </div>
  );
}
